import { SelectInput, TextInput, useListContext } from 'react-admin';
import { FormProvider, useForm } from 'react-hook-form';
import { Box, Button } from '@mui/material';

export default function OpsUserFilter() {
  const { filterValues, setFilters } = useListContext();

  const form = useForm({
    defaultValues: filterValues,
  });

  function onSubmit(values) {
    if (Object.keys(values).length > 0) {
      setFilters(values);
    } else {
      setFilters({});
    }
  }

  function onClearAll() {
    form.reset();
    setFilters({}, []);
  }

  return (
    <div style={{ marginTop: '8px' }}>
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <Box display='flex' alignItems='flex-end' mb={1}>
            <Box component='span' mr={2}>
              <TextInput helperText={false} source='id' label='ID' />
            </Box>
            <Box component='span' mr={2}>
              <TextInput helperText={false} source='name' label='Name' />
            </Box>
            <Box component='span' mr={2}>
              <TextInput helperText={false} source='email' label='Email' />
            </Box>
            <Box component='span' mr={2}>
              <SelectInput
                fullWidth
                helperText={false}
                key='status'
                label='Status'
                source='active'
                alwaysOn
                choices={[
                  { id: '', name: '' },
                  { id: 1, name: 'Active' },
                  { id: 0, name: 'Inactive' },
                ]}
              />
            </Box>
            <Box
              component='span'
              mr={2}
              mb={1.5}
              display='flex'
              alignItems='flex-end'
            >
              <Box component='span' mr={2}>
                <Button
                  variant='outlined'
                  color='primary'
                  type='submit'
                  style={{
                    borderRadius: '4px',
                    width: '120px',
                  }}
                >
                  Filter
                </Button>
              </Box>
              <Box component='span' mr={2}>
                <Button
                  variant='outlined'
                  color='primary'
                  type='button'
                  onClick={() => onClearAll()}
                  style={{
                    borderRadius: '4px',
                    width: '120px',
                  }}
                >
                  Clear All
                </Button>
              </Box>
            </Box>
          </Box>
        </form>
      </FormProvider>
    </div>
  );
}
